 <template>
    <div class="maskbg">
        <div class="dialog scaq">
            <div class="close" @click="handleClose"></div>
            <div class="flx main">
                <div class="item" v-for="(item,index) in list" :key="index" @click="show=true;content=item">
                    <div class="icon"><img class="icon" :src="item.icon" /></div>
                </div>
            </div>
        </div>
        <div class="maskbg" v-if="show">
            <div class="dialog dialog_scaq">
                <div class="close" @click="show=false"></div>
                <div class="title">{{content.name}}</div>
                <div class="main flx-bc">
                    <div class="left" v-if="content.type==='image'">
                        <!-- <swiper :options="swiperOption" ref="mySwiper" class="swiper"  v-if="content.info.length>1">
                            <swiper-slide v-for="(item, index) in content.info" :key="index">
                                <img :src="item">
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                        </swiper> -->
                        <img :src="content.info">
                    </div>
                    <div class="left" v-if="content.type==='video'">
                        <video class="video" controls :src="content.info"></video>
                    </div>
                    <div class="left" v-if="content.type==='text'">
                        <div class="text">{{content.info}}</div>
                    </div>
                    <div class="right">
                        <div class="flx-bc yxsj">
                            <div class="flx-bc item" v-for="(item,index) in content.yx" :key="index">
                                <div class="flx-lc label"><i class="icon" :class="item.value==='设备开'?'icon_on':item.value==='设备关'?'icon_off':item.value==='运行正常'?'icon_green':item.value==='运行故障'?'icon_red':item.icon"></i><span>{{['设备开关','运行情况'].includes(item.name)?item.value:item.name}}</span></div>
                                <span v-if="!['设备开关','运行情况'].includes(item.name)">{{item.value}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
    components: {swiper, swiperSlide},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                // 显示分页
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true //允许分页点击跳转
                },
                // 设置点击箭头
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            show: false,
            list: [],
            content: '',
        }
    },
    created() {
      this.getData('modelIndex')
    },
    mounted() {
    },
    methods: {
      getData(name){
        let params = {fileName: name}
        axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
          if(res.data.code === 200){
            this.list = res.data.data.scaq
            this.list.forEach(item => {
              item.icon = item.icon ? item.icon : '/assets/image/scaq/icon/' + item.name + '.png'
            })
          }
        })
      },
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
</style>